<template>
  <button
    v-if="buyFlowStore.pageState !== pageStates.selectPlan && buyFlowStore.pageState !== pageStates.reviewOrder"
    class="btn-link left-link"
    @click="go()"
  >
    <svg-icon-component icon="chevron-left" class="icon-sm" />
    {{ t("SelectPlanLink.linkText") }}
  </button>
</template>

<script setup lang="ts">
import { t } from "@/i18n";
import { useBuyFlowStore } from "@/stores/buyFlow";
import { useRoute, useRouter } from "vue-router";
import SvgIconComponent from "../shared/SvgIcon/SvgIcon.vue";
import { pageStates } from "@/components/Buy/BuyEnums";
import { buildQueryString } from "@/components/Buy/BuyHelper";
import { REFERRAL_URL_TRUSTED_DOMAINS } from "@/define";
import { logEvent } from "@/common/logger";

const route = useRoute();
const buyFlowStore = useBuyFlowStore();
const router = useRouter();

function go() {
  const referralUrl = route.query.referralUrl?.toString() || buyFlowStore.referralUrl || "";
  if (referralUrl) {
    try {
      const url = new URL(referralUrl);
      if (REFERRAL_URL_TRUSTED_DOMAINS.find(l => l === url.hostname)) {
        window.location.href = `${referralUrl}?${buildQueryString(route.query, ["referralUrl"])}`;
        return;
      }
    } catch (err) {
      //The URL is bad so don't use it
      logEvent("Referral url is not valid, it will be ignored", "SelectPlanLink");
    }
  }

  router.push({ name: "selectPlan" });
}
</script>
